import { PlusOutlined } from "@ant-design/icons"
import { Card, Typography } from "antd"
import React, { Suspense, useState } from "react"

import type { AlbumCreateData } from "../../../../../../Album/types/album.types.ts"
import { CreateAlbumModal } from "./CreateAlbumModal.tsx"

const { Text } = Typography

export const ALBUM_CARD_WITH = 250

interface CreateAlbumCardProps {
  onCreateAlbum?: (data: AlbumCreateData) => Promise<void>
}

export const CreateAlbumCard = ({ onCreateAlbum }: CreateAlbumCardProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleOpen = () => setIsModalOpen(!isModalOpen)

  return (
    <>
      {isModalOpen && (
        <Suspense>
          {/*todo add lazy */}
          <CreateAlbumModal onClose={toggleOpen} onSubmit={onCreateAlbum} />
        </Suspense>
      )}
      <Card
        hoverable
        className="h-full border-dashed flex items-center justify-center"
        styles={{
          body: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }
        }}
        onClick={toggleOpen}
      >
        <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <PlusOutlined className="text-2xl text-gray-400" />
        </div>
        <Text strong className="block mb-1">
          Create New Album
        </Text>
        <Text type="secondary" className="text-center text-sm">
          Organize your photos and documents
        </Text>
      </Card>
    </>
  )
}
